define([
    'jQuery',
    'underscore'],
    function($, _) {
        /**
         * Base class for all components
         *
         * @param element
         * @param options
         * @param elements
         * @constructor
         */
        var Component = function (element, options) {
            // Component Instance
            if(element instanceof jQuery) {
                this.element = element;
            } else {
                this.element = $(element);
            }
            
            // Widget Instance
            this.widget = null;
            
            // DOM-Element that has the Click Handler applied
            this.callerElement = null;
            
            // DOM-Element for caption output
            this.captionElement = null;            
            
            /**
             * Current options for this Widget
             */
            var defaultOptions = {
                callerElementOpenClass: 'component-is-open'
            };
            this.addOptions(defaultOptions, options);
        };

        Component.prototype = {
            /**
             * Set Caption DOM-Element
             */
            setCaptionElement: function(captionElement) {
                this.captionElement = captionElement;
            },
            
            /**
             * Get Caption DOM-Element
             */
            getCaptionElement: function() {
                return this.captionElement;
            },
            
            /**
             * Has a Caption DOM-Element
             */
            hasCaptionElement: function() {
                if(this.captionElement) {
                    return true;
                } else {
                    return false;
                }
            },
            
            /**
             * Bind Event-Handler to DOM-Element
             */
            bindEventToCallerElement: function(eventType, callerElement, eventData, callback) {
                this.setCallerElement(callerElement);
                this.getCallerElement().on(eventType, null, eventData, callback);
            },
            
            /**
             * Set Caller DOM-Element
             */
            setCallerElement: function(callerElement) {
                this.callerElement = callerElement;
            },
            
            /**
             * Get Caller DOM-Element
             */
            getCallerElement: function() {
                return this.callerElement;
            },
            
            /**
             * Has a caller DOM-Element
             */
            hasCallerElement: function() {
                if(this.callerElement) {
                    return true;
                } else {
                    return false;
                }
            },
            
            /**
             * Set Widget-Instance
             */
            setWidget: function (widget) {
                // Set Widget
                this.widget = widget;
            },
            
            /**
             * Bind Accept-Event to Widget
             */
            bindAcceptEventToWidget: function (callback) {
                this.getWidget().on("accept", callback);
            },
            
            /**
             * Bind Cancel-Event to Widget
             */
            bindCancelEventToWidget: function (callback) {
                this.getWidget().on("cancel", callback);
            },
            
           /**
             * Bind Undo-Event to Widget
             */
            bindUndoEventToWidget: function (callback) {
                this.getWidget().on("undo", callback);
            },            
            
            /**
             * Has a Widget registered
             */
            hasWidget: function() {
                if(this.getWidget()) {
                    return true;
                } else {
                    return false;
                }
            },
            
            /**
             * Get Widget-Instance
             */
            getWidget: function() {
                return this.widget;
            },
            
            /**
             * Get Element
             */
            getElement: function() {
                return this.element;
            },           
            
            /**
             * The Options
             */
            _options: {},
            
            /**
             * Adds options to the widget. 
             * The parameter options will overwrite the defaults
             * @param {object} defaults
             * @param {object|undefined} options
             * @returns {undefined}
             */
            addOptions: function(defaults, options){
                this._options = $.extend({}, this.getOptions(), defaults, options || {});
            },
            
            /**
             * Returns an object of all configuration options of the widget
             * @returns {undefined|Object}
             */
            getOptions: function(){
                return this._options;
            },
            
            /**
             * Gets or sets option
             * @param name
             * @param value optional
             */
            option: function (name, value) {
                if (!_.isUndefined(value)) {
                    this._options[name] = value;
                }
                return this._options[name];
            },
            
            /**
             * Accept method (Calls Accept-Method of a Widget)
             */
            accept: function () {
                if(this.hasWidget()) {
                    this.getWidget().accept();
                }
            },
            /**
             * Cancel (Calls Cancel-Method of a Widget)
             */
            cancel: function () {
                if(this.hasWidget()) {
                    this.getWidget().cancel();
                }
            }
        };

        return Component;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-component/component.js
// module id = 178
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21